import * as React from 'react';
import RightMenuPanel from './rightMenuPanel';
import * as Styled from '../mainMenu/navigationbarStyle';

const SubMenu = (props) => {
  return (
    <Styled.Layout onMouseLeave={(e) => props.onMouseLeave()}>
      {props?.menuDetails?.subNavigations ? (
        <Styled.InnerLayout>
          <Styled.RightLayout>
            <RightMenuPanel
              navigationType={props?.menuDetails?.type}
              menu={props?.menuDetails?.subNavigations}
            />
          </Styled.RightLayout>
        </Styled.InnerLayout>
      ) : (
        ''
      )}
    </Styled.Layout>
  );
};

export default SubMenu;
